/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferences — Your tool settings, team selections, and other personalization choices.`)
};

const es_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencias — Tus configuraciones de herramientas, selecciones de equipo y otras opciones de personalización.`)
};

const de_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen — Ihre Werkzeugeinstellungen, Teamauswahlen und andere Personalisierungsoptionen.`)
};

const nl_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorkeuren — Uw toolinstellingen, teamselecties en andere personalisatiekeuzes.`)
};

const fr_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préférences — Vos paramètres d’outils, sélections d’équipe et autres choix de personnalisation.`)
};

const it_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferenze — Le tue impostazioni degli strumenti, selezioni del team e altre scelte di personalizzazione.`)
};

const pt_br2_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferências — Suas configurações de ferramentas, seleções de equipe e outras escolhas de personalização.`)
};

const pt_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferências — As suas definições de ferramentas, seleções de equipa e outras escolhas de personalização.`)
};

const ja_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定 — ツールの設定、チーム選択、その他のパーソナライゼーション。`)
};

const zh_privacy_info_preferences = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`偏好设置 — 您的工具设置、车队选择和其他个性化选项。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_info_preferences = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_info_preferences(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_info_preferences", locale)
	if (locale === "en") return en_privacy_info_preferences(inputs)
	if (locale === "es") return es_privacy_info_preferences(inputs)
	if (locale === "de") return de_privacy_info_preferences(inputs)
	if (locale === "nl") return nl_privacy_info_preferences(inputs)
	if (locale === "fr") return fr_privacy_info_preferences(inputs)
	if (locale === "it") return it_privacy_info_preferences(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_info_preferences(inputs)
	if (locale === "pt") return pt_privacy_info_preferences(inputs)
	if (locale === "ja") return ja_privacy_info_preferences(inputs)
	return zh_privacy_info_preferences(inputs)
};